import { copy } from "utils/method";

/** 注册流程内暂存邀请码，供跳转后 Download 仍可读取 */
const REGISTER_INVITE_REF_KEY = "register_invite_ref";

export function getStoredInviteRef() {
  if (typeof window === "undefined") return "";
  try {
    return sessionStorage.getItem(REGISTER_INVITE_REF_KEY)?.trim() || "";
  } catch (_) {
    return "";
  }
}

export function persistInviteRef(ref) {
  if (typeof window === "undefined") return;
  const code = String(ref || "").trim();
  if (!code) return;

  try {
    sessionStorage.setItem(REGISTER_INVITE_REF_KEY, code);
  } catch (_) {
    // ignore quota / private mode
  }
}

export function resolveInviteRef(query) {
  const fromQuery = query?.ref != null ? String(query.ref).trim() : "";
  if (fromQuery) return fromQuery;

  if (typeof window === "undefined") return "";

  const fromUrl = new URLSearchParams(window.location.search).get("ref");
  if (fromUrl?.trim()) return fromUrl.trim();

  return getStoredInviteRef();
}

export async function copyInviteRefToClipboard(ref) {
  const code = String(ref || "").trim();
  if (!code) return false;

  try {
    if (typeof navigator !== "undefined" && navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(code);
      return true;
    }
  } catch (_) {
    // fall through to execCommand
  }

  return copy(code) === true;
}

/** 点击 Download APP 时调用：解析 ref 并写入系统剪切板 */
export function copyInviteRefOnDownload(query) {
  const ref = resolveInviteRef(query);
  if (!ref) return Promise.resolve(false);
  return copyInviteRefToClipboard(ref);
}
